'use client'

import React from 'react'

import { useI18n } from '@/shared/providers'
import { ErrorWidget } from '@/widgets/error'
import { NavbarError } from '@/widgets/navbar/navbar-error'

export function ErrNotFound() {
    const { i18n } = useI18n()

    return (
        <React.Fragment>
            <NavbarError />
            <ErrorWidget statusCode={404} title={i18n.TEXT_PAGE_NOT_FOUND} />
        </React.Fragment>
    )
}
